import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useAgreementTemplateQuery } from '@uplift/queries';
import { CollaborativeAgreementExpiring } from '@uplift/api';
import { Error } from '@mui/icons-material';
import { makeStyles } from 'tss-react/mui';


const useCollaborativeAgreementExpiringListItemStyles = makeStyles()(theme => ({
  root: {
    background: `linear-gradient(to right, ${theme.palette.warning.background}, #fff, #fff)`,

    '&.Mui-selected': {
      borderRight: '3px solid',
      borderRightColor: theme.palette.secondary.main,
      background: `linear-gradient(to right, ${theme.palette.warning.background}, ${theme.palette.grey[100]}, ${theme.palette.grey[100]})`,
    }
  },
}));

export const CollaborativeAgreementExpiringListItem: React.VFC<{
  document: CollaborativeAgreementExpiring;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  const { classes } = useCollaborativeAgreementExpiringListItemStyles();
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);

  return (
    <ListItemButton
      onClick={onClick}
      selected={selected}
      className={classes.root}
    >
      <ListItemIcon><Error color="warning" /></ListItemIcon>
      <ListItemText
        primary={template.name}
        secondary="Renewal needed"
      />
    </ListItemButton>
  );
};
